import {assertUnreachable} from '/shared/utils'

export {DateType} from './date-type'

export const supported = ['en', 'ru'] as const

export type Locale = typeof supported[number]

export const languages: Record<Locale, string> = {
    ru: 'Русский',
    en: 'English',
}

export function isSupported(locale: string): locale is Locale {
    return supported.includes(locale as any)
}

export function stripCountries(locales: readonly string[]): string[] {
    return locales.map(l => l.split('-')[0] ?? l)
}

export function selectSupported(locales: readonly string[]): Locale | null {
    for (const l of stripCountries(locales))
        if (isSupported(l))
            return l
    return null
}

export type Translation = typeof import('./en').obj

export async function loadTranslation(locale: Locale): Promise<Translation> {
    if (locale === 'en')
        return (await import('./en')).obj
    else if (locale === 'ru')
        return (await import('./ru')).obj
    else
        assertUnreachable(locale)
}

let current!: Translation

export function setTranslation(tr: Translation) {
    current = tr
}

export {current as default}
